import { hashHistory } from 'react-router';

import { toast } from '@finn-no/common-browserbundle';
import { trackEvent } from '../../../services/trackingService.js';

import { NEW_AGREEMENT_DATA_RECEIVED } from '../agreement/agreementActionTypes.js';
import {
    NEW_PAYMENT_DATA_RECEIVED,
    CREATE_PAYLINK_START,
    CREATE_PAYLINK_ERROR,
    APPROVE_ITEM_START,
    APPROVE_ITEM_SUCCESS,
    APPROVE_ITEM_ERROR,
    APPROVE_DISCOUNT_START,
    APPROVE_DISCOUNT_SUCCESS,
    APPROVE_DISCOUNT_ERROR,
    DELAY_PAYMENT_START,
    DELAY_PAYMENT_SUCCESS,
    DELAY_PAYMENT_ERROR,
    SUGGEST_DISCOUNT_START,
    SUGGEST_DISCOUNT_SUCCESS,
    SUGGEST_DISCOUNT_ERROR,
} from './paymentActionTypes.js';
import { UPDATED_SAFE_TRADE_STATUS } from '../safeTradeActionTypes.js';
import actions from '../../viewActions.js';
import mapResponse from '../../responseMapper.js';
import { post, put } from '../../../services/jsonfetchservice.js';

export function createPaylink({ itemType, itemId }) {
    trackEvent('trade.buyer-pays.buyer-starts-payment-process', 'start');

    return dispatch => {
        dispatch({
            type: CREATE_PAYLINK_START,
        });

        return post(`/safe-trade/${itemType}/${itemId}/pay.json`)
            .then(response => response.json())
            .then(({ url }) => {
                window.location.href = url;
            })
            .catch(error => {
                if (error.status === 400) {
                    return error.json().then(({ code = '' } = {}) => {
                        if (
                            code === 'OUT_OF_SYNC' ||
                            code === 'ILLEGAL_ACTION'
                        ) {
                            dispatch({
                                type: CREATE_PAYLINK_ERROR,
                            });
                            window.location.reload();
                            return;
                        }

                        if (code === 'USER_IS_NOT_VERIFIED') {
                            dispatch({
                                type: CREATE_PAYLINK_ERROR,
                            });
                            hashHistory.replace('/betaling-feilet/1');
                            return;
                        }
                        throw new Error(`Unhandled code ${code}`);
                    });
                }
                throw error;
            })
            .catch(() => {
                dispatch({
                    type: CREATE_PAYLINK_ERROR,
                });
                hashHistory.replace('/betaling-feilet');
            });
    };
}

export function forceRefresh(orderId) {
    return () => post('/safe-trade/force-refresh.json', { orderId });
}

function updateStatus({
    actionType,
    body = {},
    dispatch,
    errorType,
    itemId,
    itemType,
    partnerId,
    redirectOnError,
    successType,
    startType,
    toastMessage,
}) {
    dispatch({
        type: startType,
    });

    const payload = Object.assign(
        {},
        {
            actionType,
        },
        body
    );

    return put(`/safe-trade/${itemType}/${itemId}/${partnerId}.json`, payload)
        .then(response => response.json())
        .then(data => mapResponse(data, partnerId, itemType, itemId))
        .then(mappedResponse => {
            dispatch({
                type: NEW_AGREEMENT_DATA_RECEIVED,
                payload: mappedResponse.agreement,
            });

            dispatch({
                type: NEW_PAYMENT_DATA_RECEIVED,
                payload: mappedResponse.payment,
            });

            dispatch({
                type: UPDATED_SAFE_TRADE_STATUS,
                payload: mappedResponse.safeTrade.viewStatus,
            });

            dispatch({
                type: successType,
            });
            hashHistory.replace('/samtale');
            if (toastMessage) {
                toast({ message: toastMessage });
            }
        })
        .catch(() => {
            dispatch({
                type: errorType,
            });
            hashHistory.replace(redirectOnError);
        });
}

export function approveItem({ itemType, itemId, partnerId }) {
    trackEvent('trade.buyer-approves-item.buyer-release-money', 'success');

    return dispatch =>
        updateStatus({
            dispatch,
            itemType,
            itemId,
            partnerId,
            actionType: actions.APPROVE_ITEM,
            startType: APPROVE_ITEM_START,
            successType: APPROVE_ITEM_SUCCESS,
            errorType: APPROVE_ITEM_ERROR,
            redirectOnError: '/godkjenn-vare-feilet',
        });
}

export function approveDiscount({ itemType, itemId, discount, partnerId }) {
    trackEvent(
        'trade.buyer-does-not-approve-item.buyer-approves-discount',
        'success'
    );

    return dispatch =>
        updateStatus({
            dispatch,
            itemType,
            itemId,
            partnerId,
            body: { discount },
            actionType: actions.APPROVE_DISCOUNT,
            startType: APPROVE_DISCOUNT_START,
            successType: APPROVE_DISCOUNT_SUCCESS,
            errorType: APPROVE_DISCOUNT_ERROR,
            redirectOnError: '/losning/godta-avslag-feilet',
        });
}

export function delayPayment({ itemType, itemId, partnerId }) {
    trackEvent('trade.buyer-does-not-approve-item.postpone-payment', 'success');

    return dispatch =>
        updateStatus({
            dispatch,
            itemType,
            itemId,
            partnerId,
            actionType: actions.DELAY_PAYMENT,
            startType: DELAY_PAYMENT_START,
            successType: DELAY_PAYMENT_SUCCESS,
            errorType: DELAY_PAYMENT_ERROR,
            redirectOnError: '/losning/utsett-betaling-feilet',
            toastMessage: 'Betalingen er utsatt',
        });
}

export function suggestDiscount({
    itemType,
    itemId,
    discount,
    partnerId,
    partnerSuggestedCurrentDiscount,
}) {
    trackEvent(
        partnerSuggestedCurrentDiscount
            ? 'trade.buyer-does-not-approve-item.buyer-suggests-other-discount'
            : 'trade.buyer-does-not-approve-item.buyer-suggests-discount'
    );

    return dispatch =>
        updateStatus({
            dispatch,
            itemType,
            itemId,
            partnerId,
            body: { discount },
            actionType: actions.SUGGEST_DISCOUNT,
            startType: SUGGEST_DISCOUNT_START,
            successType: SUGGEST_DISCOUNT_SUCCESS,
            errorType: SUGGEST_DISCOUNT_ERROR,
            redirectOnError: '/losning/foresla-avslag-feilet',
            toastMessage: 'Forslaget er sendt',
        });
}



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/paymentActions.js